import Axios from "axios";
const ElementUI = require('element-ui')
import router from "../../router";
const sha1 = require('js-sha1')
Axios.defaults.baseURL = process.env.VUE_APP_URL;
Axios.defaults.timeout = 60*1000;
// Axios.defaults.retry = 4;
// Axios.defaults.retryDelay = 1000;
Axios.interceptors.request.use(config => {
	// 跳过拦截器，这里不拼接多余url
	if (config.skipInterceptors) {
		//需要验签
		if (config.isSignature) {
			// 只验证时间戳的签名流程
			let dateNow = Date.now()
			config.url = config.url + (config.url.indexOf('?') == -1 ? '?' : '&') + 'Timestamp=' + dateNow
			let signature = 'Timestamp=' + dateNow + '&' + 'SD23k123!@$sad'
			config.headers['auth-sign'] = sha1(signature)
		}
		return config
	}

	if (config.url == '/auth/register' || config.url == '/auth/forget-password') {
		// 注册+忘记密码
		if (sessionStorage.getItem('signature')) {
			config.headers.signature = JSON.parse(sessionStorage.getItem('signature'))
		}
	}

	// 添加token
	if (config.push !== '/' && config.url != '/auth/login') {
		if (sessionStorage.getItem('token')) {
			config.headers.token = sessionStorage.getItem('token');
		}
	}

	// 如果是公共接口，则不添加login和省份信息
	if (config.commonApi) {
		config.url = '/api' + config.url
		// 只验证时间戳的签名流程
		let dateNow = Date.now()
		config.url = config.url + (config.url.indexOf('?') == -1 ? '?' : '&') + 'Timestamp=' + dateNow
		let signature = 'Timestamp=' + dateNow + '&' + 'SD23k123!@$sad'
		config.headers['auth-sign'] = sha1(signature)
		return config
	}

	// 对请求进行统一管理  分端添加接口
	if (!config.headers['split_loginRole']) {
		// 默认没有该字段	自动添加当前登录角色全称前缀
		config.url = '/competition_course/organization/' + sessionStorage.getItem('loginRole') + config.url
	} else {
		// headers添加split_loginRole字段	不添加角色全称前缀
		config.url = '/competition_course/organization' + config.url
		delete config.headers.split_loginRole
	}
	// 接口是否需要加省份拼音
	if (!config.headers['split_province']) {
		// 默认	自动添加当前省份的拼音前缀
		if (!sessionStorage.getItem('province_name')) {
			// 预防当省份未存进去时，重新存一遍
			if (window.location.hostname.indexOf('jxjy') != -1) {
				// 江西
				sessionStorage.setItem('province_name', 'jiangxi');
			} else if (window.location.hostname.indexOf('scjy') != -1) {
				// 四川
				sessionStorage.setItem('province_name', 'sichuan');
			} else if (window.location.hostname.indexOf('bjjy') != -1) {
				// 北京
				sessionStorage.setItem('province_name', 'beijing');
			} else if (window.location.hostname.indexOf('hnjy') != -1) {
				// 河南
				sessionStorage.setItem('province_name', 'henan');
			} else if (window.location.hostname.indexOf('jsjy') != -1) {
				// 江苏
				sessionStorage.setItem('province_name', 'jiangsu');
			} else if (window.location.hostname.indexOf('hainanjy') != -1) {
				// 海南
				sessionStorage.setItem('province_name', 'hainan');
			} else if (window.location.hostname.indexOf('fjjy') != -1) {
				// 福建
				sessionStorage.setItem('province_name', 'fujian');
			} else if (window.location.hostname.indexOf('gdjy') != -1) {
				// 广东
				sessionStorage.setItem('province_name', 'guangdong');
			} else if (window.location.hostname.indexOf('ahjy') != -1) {
				// 安徽
				sessionStorage.setItem('province_name', 'anhui');
			} else if (window.location.hostname.indexOf('xjjy') != -1) {
				// 新疆
				sessionStorage.setItem('province_name', 'xinjiang');
			} else if (window.location.hostname.indexOf('sxjy') != -1) {
				// 山西
				sessionStorage.setItem('province_name', 'shanxi');
			} else {
				// 本地 测试
				// sessionStorage.setItem('province_name', 'jiangxi');
			}
		}
		config.url = sessionStorage.getItem('province_name') + config.url
	} else {
		// headers添加split_province字段	不添加省份的拼音前缀
		delete config.headers.split_province
	}
	// 只验证时间戳的签名流程
	let dateNow = Date.now()
	config.url = config.url + (config.url.indexOf('?') == -1 ? '?' : '&') + 'Timestamp=' + dateNow
	let signature = 'Timestamp=' + dateNow + '&' + 'SD23k123!@$sad'
	config.headers['auth-sign'] = sha1(signature)
	return config;
}, error => {
	ElementUI.Message({
		message: '请求错误！',
		type: 'error'
	});
});
Axios.interceptors.response.use(response => {
	let str = JSON.stringify(response.headers)
	let code = response.data?.code;
	let msg = response.data?.msg || '';
	if (str.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') != -1 || str.indexOf(
			'application/vnd.ms-excel') != -1 || str.indexOf('application/image') != -1) {
		return response
	} else {
		if (code == 401001) {
			//token过期
			ElementUI.Message({
				message: '身份已失效,请重新登录！',
				type: 'error'
			});
			localStorage.clear();
			sessionStorage.clear()
			router.push({
				name: 'region'
			});
			return
		} else if (code == 200) {
			return response.data
		} else {
			if (response.config.params && response.config.params.notNeedMsgTip) {
				// 无需提示
			} else if (msg) {
				ElementUI.Message({
					message: msg,
					type: 'error'
				});
			}
			return response
		}
	}
}, error => {
	return Promise.reject(error);
})